module.exports = __webpack_public_path__ + "fonts/a8f7f6d35a5cad72e1d8d40a4fdc5880.txt";